// Profil jazykové mutace — na co se formulář ptá, co ukazuje a jak počítá ceny.
// Nahrazuje podmínky typu `lang === 'cs'` roztroušené po komponentách: přidání
// další mutace je pak jeden záznam tady, ne dohledávání větví napříč .vue soubory.
//
// Čte se ze dvou míst:
//   store.js    — profileFor(import.meta.env.VITE_LANGUAGE); store není komponenta,
//                 takže bere jazyk z build-time env
//   komponenty  — useLocaleProfile(); reaktivní na i18n locale kvůli debug
//                 přepínači jazyka v App.vue

// Česká mutace: ptá se na typ činnosti, počítá s korunovým ceníkem a slevovou akcí.
const cs = {
    isLang: 'CZ',                          // hodnota do Raynetu — v jaké mutaci objednávka vznikla
    isProductLang: 'cs',                   // languageId, pod kterým IS vrací překlad názvu produktu
    productNamesFromCatalog: false,        // názvy produktů z katalogu IS místo locales, viz useProductName.js
    defaultPhonePrefix: '420',             // předvyplněná předvolba telefonu ve StepTwo
    currency: 'CZK',                       // ceník a měna košíku; v buildu ji určuje VITE_CURRENCY
    priceFormat: 'cs',                     // locale pro Intl → 1 234 Kč; null = kód měny před číslem
    pricing: 'standard',                   // standardPrice + DPH (jinak cena z eurového ceníku)
    showSalePromo: true,                   // slevový badge a text o akci
    showTradeListAnchor: true,             // kotva ↓ na seznam oborů živnosti
    askTradeType: true,                    // radio hlavní/vedlejší činnost
    offerTaxReturnService: true,           // checkbox zpracování daňového přiznání
    czTypography: true,                    // české skládání vět a zalomení (NeedHelp, ThankYou)
    askResidency: false,                   // blok rezidence v ČR
    askEconomicActivity: false,            // blok ekonomické činnosti
    flatRateNeedsPrimaryActivity: false,   // paušální daň jen při hlavní činnosti
    showAddressHint: false,                // nápověda "ulice a číslo popisné" u adresy
};

// Zahraniční mutace: zákazník zakládá českou živnost zvenčí, takže se ptáme na
// rezidenci a ekonomickou činnost, a ceny jdou z eurového ceníku.
const foreign = {
    isLang: 'EN',
    isProductLang: 'en',
    productNamesFromCatalog: false,
    defaultPhonePrefix: '420',
    currency: 'EUR',
    priceFormat: null,                     // vlastní lokalizovaný zápis nemá → EUR 1 234
    pricing: 'priceList',
    showSalePromo: false,
    showTradeListAnchor: false,
    askTradeType: false,
    offerTaxReturnService: false,
    czTypography: false,
    askResidency: true,
    askEconomicActivity: true,
    flatRateNeedsPrimaryActivity: true,
    showAddressHint: true,
};

export const localeProfiles = {
    cs,
    en: foreign,
    sk: {...foreign, isLang: 'SK', isProductLang: 'sk', productNamesFromCatalog: true, defaultPhonePrefix: '421', priceFormat: 'sk'},
    pl: {...foreign, isLang: 'PL', isProductLang: 'pl', defaultPhonePrefix: '48'},
    de: {...foreign, isLang: 'DE', isProductLang: 'de', defaultPhonePrefix: '49'},
};

// Neznámý jazyk se chová jako zahraniční mutace — stejně jako původní zápis
// `VITE_LANGUAGE === 'cs' ? 'CZ' : 'EN'`, kde do EN větve spadlo všechno kromě češtiny.
export function profileFor(lang) {
    return localeProfiles[lang] || localeProfiles.en;
}
